const INITIAL_STATE = {  }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CONFIGURACAO_FETCHED':
            return { ...state, configuracao:  action.payload.data }
        
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/configuracoes/configuracaoReducer.js